/** Описывает runtime-поля, доступные странице региона. */
export interface RuntimeConfigBase extends Record<string, string | undefined> {
  VITE_RUNTIME_API_URL?: string;
  VITE_RUNTIME_SOGU_SERVICE_URL: string;
  VITE_RUNTIME_SENTRY_DSN: string;
  VITE_RUNTIME_CANONICAL_URL: string;
}

/** Возвращает расширенный runtime-конфиг без изменения его значений. */
export const initRuntimeConfigExtends = (runtimeConfig: RuntimeConfigBase): RuntimeConfigBase => runtimeConfig;
